import { render, staticRenderFns } from "./DatosGenerales.vue?vue&type=template&id=787304f1&scoped=true&"
import script from "./DatosGenerales.vue?vue&type=script&lang=js&"
export * from "./DatosGenerales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787304f1",
  null
  
)

export default component.exports